import(/* webpackMode: "eager" */ "/Users/chadlinmaalgraaff/Desktop/Skywalk/Pattern/pattern-dashboard/src/app/global-error.tsx");
